import React, { useEffect, useRef, useState } from 'react';
import './About.css';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="about" id="about" ref={sectionRef}>
      <div className="about-container">
        <div className="mission-section">
          <div className="story-container">
            <div className="story-content">
              <h2 className={isVisible ? 'visible' : ''}>Built for Belonging. <br></br>Backed by Science.</h2>
              <p className={isVisible ? 'visible' : ''} style={{transitionDelay: '0.2s'}}>
              <b>Attenxion was founded with a simple belief</b>: Everyone deserves the tools to thrive at work — <b>especially those whose minds work differently. </b>
              Despite growing awareness of the value <b>neurodivergent thinkers</b> bring to teams, too many workplaces still rely on systems that unintentionally
               exclude them. <b>We spent years collaborating</b> with neurodivergent professionals, HR leaders, managers, and researchers to understand the real barriers
                — and opportunities — for inclusion. <b>Our AI copilot is the result of that work</b>: a tool designed from the ground up to <b>reduce cognitive friction, support diverse workstyles, and help teams unlock their full potential.</b>
              </p>
              <div className={`about-image ${isVisible ? 'visible' : ''}`} style={{transitionDelay: '0.3s'}}>
              <img
                src="/about-image.png"
                alt="About Attenxion"
              />
            </div>
              <p className={isVisible ? 'visible' : ''} style={{transitionDelay: '0.4s'}}>
                By combining cutting-edge AI with deep insights into diverse cognitive styles, 
                we're creating tools that truly empower people to achieve their full potential — a mission guided by our <b>core values</b>:
              </p>
            </div>
            
            <div className={`values-grid ${isVisible ? 'visible' : ''}`} style={{transitionDelay: '0.5s'}}>
              <div className={`value-item ${isVisible ? 'visible' : ''}`} style={{transitionDelay: '0.6s'}}>
                <div className="value-icon">
                  <img src="/puzzlepiece.png" alt="Puzzle piece icon" />
                </div>
                <h4>Design for individuals</h4>
                <p>Built to support every mind, every workstyle, every person — not just the average.</p>
              </div>
              <div className={`value-item ${isVisible ? 'visible' : ''}`} style={{transitionDelay: '0.7s'}}>
                <div className="value-icon">
                  <img src="/lightbulb.png" alt="Lightbulb icon" />  
                </div>
                <h4>Innovate with Evidence</h4>
                <p>Solutions grounded in research, shaped by lived experience, and built to make a real difference.</p>
              </div>
              <div className={`value-item ${isVisible ? 'visible' : ''}`} style={{transitionDelay: '0.8s'}}>
                <div className="value-icon">
                  <img src="/bullseye.png" alt="Bullseye icon" />
                </div>
                <h4>Turn Intention into Impact</h4>
                <p>Bridging the gap between ambition and achievement.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 